module.exports = __webpack_public_path__ + "static/media/NUS_school_computing.5fb2d4f8.png";